import { useEffect } from 'react';
import { initFacebookPixel, trackPixelEvent } from '@/config/facebook/pixel';

export const useFacebookPixel = () => {
  useEffect(() => {
    initFacebookPixel();
  }, []);

  return { trackPixelEvent };
};